<template>
    <div>
        <b-modal 
            v-model="mostrarModalSolicitarDiligenciaFornecedor" 
            @hidden="fecharModal()" 
            size="md" 
            no-close-on-backdrop
        >
            <div slot="modal-title">Solicitar Diligência Fornecedor</div>

            <b-row>
                <b-col>
                    <b-form-group>
                        <label for="justificativa-diligencia" class="required">Justificativa</label>
                        <b-form-textarea
                            id="justificativa-diligencia"
                            v-model="justificativaDiligencia"
                            rows="3"
                            max-rows="6"
                            :no-resize="true"
                            @input="$v.justificativaDiligencia.$touch()"
                            :state="$v.justificativaDiligencia.$error ? false : null"
                        />
                        <b-form-invalid-feedback v-if="!$v.justificativaDiligencia.required && $v.justificativaDiligencia.$dirty">
                            Justificativa é obrigatória.
                        </b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.justificativaDiligencia.maxLength && $v.justificativaDiligencia.$dirty">
                            Justificativa deve ter no máximo 500 caracteres.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group>
                        <label for="nota-tecnica-diligencia" class="required">Anexar Nota Técnica</label>
                        <b-form-file
                            id="nota-tecnica-diligencia"
                            v-model="arquivoNotaTecnica"
                            ref="selecaoArquivo"
                            placeholder="Selecione o arquivo..."
                            browse-text="Selecione o arquivo"
                            accept=".pdf"
                            @input="validarArquivoNotaTecnica"
                        ></b-form-file>
                        <b-form-invalid-feedback :state="arquivoNotaTecnica && arquivoNotaTecnicaValido">
                            O arquivo deve ter no máximo 10MB.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button 
                    ref="btnCancelar"
                    class="mr-2"
                    variant="secondary" 
                    @click.stop="fecharModal()" 
                >
                    Cancelar
                </b-button>

                <b-button
                    ref="btnConfirmar"
                    variant="primary"
                    :disabled="$v.$invalid || !arquivoNotaTecnicaValido"
                    @click.stop="confirmarSolicitarDiligenciaFornecedor"
                >
                    Confirmar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import PropostaPrecoServico from '../PropostaPrecoServico';
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
    name: 'ModalSolicitarDiligenciaFornecedor',
    props: {
        mostrarModal: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            mostrarModalSolicitarDiligenciaFornecedor: this.mostrarModal,
            justificativaDiligencia: '',
            arquivoNotaTecnica: null,
            arquivoNotaTecnicaValido: false,
        }
    },

    computed: {
    },

    validations: {
        justificativaDiligencia: {
            required,
            maxLength: maxLength(500)
        },
    },

    methods: {

        limparForm(){
            this.justificativaDiligencia = '';
            this.arquivoNotaTecnica = null;
            this.arquivoNotaTecnicaValido = false;
            this.$v.$reset();
        },

        validarArquivoNotaTecnica(file) {
            const umMega = 1024 * 1024;
            const maxSize = 10 * umMega;
            this.arquivoNotaTecnicaValido = !!(file && file.size <= maxSize);
        },

        fecharModal() {
            this.mostrarModalSolicitarDiligenciaFornecedor = false;
            this.limparForm();
            this.$emit('update:mostrarModal', this.mostrarModalSolicitarDiligenciaFornecedor);
        },

        confirmarSolicitarDiligenciaFornecedor() {
            this.$swal({
                title: 'Confirmação',
                html: `Deseja confirmar o envio da solicitação de diligência ao fornecedor?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.solicitarDiligenciaFornecedor();
                }
            })
        },

        solicitarDiligenciaFornecedor(){
            const dto = {
                justificativa: this.justificativaDiligencia,
                notaTecnica: this.arquivoNotaTecnica
            }

            this.$store.dispatch('addRequest')

            PropostaPrecoServico.SolicitarDiligenciaFornecedor(this.$route.params.propostaPrecoId, dto)
                .then(response => {
                    if (response.success) {
                        this.$toast.success('Diligência solicitada com sucesso', 'Sucesso', this.$toastConfig.success);
                        this.fecharModal();
                        this.$emit('diligenciaFornecedorSolicitada');
                    } else {
                        this.erros = response.errors || ['Erro ao solicitar diligência ao fornecedor'];
                        this.$toast.error(
                            'Erro ao solicitar diligência ao fornecedor!',
                            'Erro',
                            this.$toastConfig.error
                        );
                    }
                })
                .catch(error => {
                    console.error('Erro ao solicitar diligência ao fornecedor:', error);
                    this.erros = [`Erro ao solicitar diligência ao fornecedor: ${error}`];
                    this.$toast.error(
                        'Erro ao solicitar diligência ao fornecedor!',
                        'Erro',
                        this.$toastConfig.error
                    );
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                });
        },

    },

    watch: {
        mostrarModal(newVal) {
            this.mostrarModalSolicitarDiligenciaFornecedor = newVal;
        },
    }
}
</script>